<!-- Общий вид панели навигации -->
<template>
    <b-container fluid>
        <h1 class="text-center my-3">
            {{ caption }}
        </h1>
        <div class="d-flex flex-wrap justify-content-start">
            <menu-item
                v-for="item in menuItems"
                :key="item.to"
                :to="item.to"
                :title="item.title"
                :description="item.description"
            >
                <template #icon>
                    <component :is="item.componentName" class="w-100 h-100" />
                </template>
            </menu-item>
        </div>
    </b-container>
</template>

<script>
import Vue from 'vue';
import MenuItem from '@/components/Navigation/NavsMenuItem.vue';

export default Vue.extend({
    name: 'Navigation',
    components: {
        MenuItem,
    },
    props: {
        menuItems: {
            type: Array,
            required: true,
        },
        caption: {
            type: String,
            required: true,
        },
    },
});
</script>
